import React, { useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardContent, Box, TextField, Button, Paper, Typography, useTheme } from "@mui/material";
import {DateFormat} from "../../../../Utils/DateFormatPatternUtils";
import {TicketMessage} from "../../../../Shared/Types/Ticket";
import {FindTicketMessages, SendTicketMessage} from "../TicketReactQuery";
import {useAppSelector} from "../../../../Config/Hooks";

type MessageBalloonProps = {
    message: TicketMessage;
    isUserMessage: boolean;
};

const MessageBalloon = ({ message, isUserMessage }: MessageBalloonProps) => {
    return (
        <Box
            display="flex"
            flexDirection={isUserMessage ? 'row-reverse' : 'row'}
            alignItems="flex-start"
            mb={2}
        >
            {/* Avatar de quem enviou a mensagem */}
            {/* <Avatar alt="User" src="https://via.placeholder.com/40" sx={{ mr: 1 }} /> */}

            {/* Balão de mensagem */}
            <Paper
                sx={{
                    p: 1,
                    borderRadius: 2,
                    maxWidth: '90%',
                    borderStyle: "solid",
                    boxShadow: 1,
                    
                }}
            >
                <Typography sx={{ marginBottom: "10px" }} variant="body1">{message.description}</Typography>
                <Typography variant="caption">{message.date ? DateFormat(message.date, "dd/MM HH:mm") : ""} - {message.userName}</Typography>
            </Paper>
        </Box>
    );
};

type TicketMessagesProps = {
    ticketId?: number;
    disabled: boolean;
};

const TicketMessages = ({ticketId, disabled}: TicketMessagesProps) => {
    const theme = useTheme();
    const [messages, setMessages] = useState<Array<TicketMessage>>([]); // Armazena as mensagens do chat
    const [newMessage, setNewMessage] = useState(""); // Armazena a nova mensagem digitada
    const listRef = useRef<HTMLDivElement>(null);
    const {data: findTicketMessages} = FindTicketMessages(ticketId);
    const mutationSend = SendTicketMessage(ticketId);
    const account = useAppSelector((state) => state.authentication.account);

    // Função para enviar a mensagem
    const sendMessage = () => {
        if (ticketId !== null && newMessage.trim() !== "") {
            const handleSuccess = (res: any) => {
                setMessages([
                    ...messages,
                    res.data
                ]);
                setNewMessage(""); // Limpar o campo de texto após enviar
            };
            mutationSend.mutate({ ticketId: Number(ticketId), message: newMessage }, { onSuccess: handleSuccess });
        }
    };

    useEffect(() => {
        if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight; // Força o scroll para o final
        }
    }, [messages]);

    useEffect(() => {
        if (findTicketMessages !== undefined) {
            setMessages(findTicketMessages.data);
        }
    }, [findTicketMessages]);

    return (
        <Card sx={{
            borderRadius: 4,
            boxShadow: 2,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: theme.palette.primary.main,
        }}>
            <CardHeader
                sx={{ paddingBottom: 0 }}
                title={
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        ATENDIMENTO
                    </Typography>
                }
            />
            <CardContent sx={{
                paddingTop: 0
            }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    padding: 0,
                  }}
                >
                  {/* Área de mensagens */}
                  <Paper
                    ref={listRef}
                    sx={{
                      flex: 1,
                      overflowY: "auto",
                      padding: "5px",
                      minHeight: "220px",
                      maxHeight: "220px",
                      boxShadow: 'none',
                    }}
                  >
                      {messages.map((message, index) => (
                          <MessageBalloon key={index} message={message} isUserMessage={message.userId === account?.id} />
                      ))}
                  </Paper>

                  {/* Campo para digitar nova mensagem */}
                  <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 1
                  }}>
                    <TextField
                      fullWidth
                      label="Digite sua mensagem..."
                      variant="outlined"
                      size={"small"}
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      sx={{ marginRight: "10px"}}
                      disabled={disabled}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      size={"small"}
                      onClick={sendMessage}
                      disabled={disabled}
                    >
                      Enviar
                    </Button>
                  </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default TicketMessages;